import { Typography } from "components/atoms";
import "./index.scss";

interface IProps {
  questionsAttempted: number;
  correctAnswers: number;
  wrongAnswers: number;
}

export const AiOverAllCard = ({
  correctAnswers,
  questionsAttempted,
  wrongAnswers,
}: IProps) => {
  return (
    <div className="ai-overall-card-wrapper">
      <div className="title-section">
        <Typography label="Overall" variant="h6Bold" />
      </div>
      <div className="content-section">
        {/* <div className="first"> */}
          <div className="up-row">
            <div className="topic">
              <Typography
                label="Questions attempted"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
              <Typography
                label=":"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
            </div>
            <div className="result">
              <Typography
                variant="h7Book"
                label={`${questionsAttempted}`}
                styles="result-typography-custom-style"
              />
            </div>
          </div>
          <div className="down-row">
            <div className="topic">
              <Typography
                label="Wrong answers"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
              <Typography
                label=":"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
            </div>
            <div className="result">
              <Typography
                variant="h7Book"
                label={`${wrongAnswers}`}
                styles="result-typography-custom-style"
              />
            </div>
          </div>
        {/* </div> */}
        {/* <div className="second"> */}
          <div className="up-row">
            <div className="topic">
              <Typography
                label="Correct answers"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
              <Typography
                label=":"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
            </div>
            <div className="result">
              <Typography
                variant="h7Book"
                label={`${correctAnswers}`}
                styles="result-typography-custom-style"
              />
            </div>
          </div>
          {/* <div className="down-row">
            <div className="topic">
              <Typography
                label="Wrong answers"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
              <Typography
                label=":"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
            </div>
            <div className="result">
              <Typography
                variant="h7Book"
                label="20"
                styles="result-typography-custom-style"
              />
            </div>
          </div> */}
        {/* </div> */}
        {/* <div className="third"> */}
          <div className="up-row">
            <div className="topic">
              <Typography
                label="Overall result"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
              <Typography
                label=":"
                variant="h7Med"
                styles="topic-typography-custom-style"
              />
            </div>
            <div className="result">
              <Typography
                variant="h7Book"
                label={`${((correctAnswers/questionsAttempted)*100).toFixed(2)}%`}
                styles="result-typography-custom-style"
              />
            </div>
          </div>
        {/* </div> */}
      </div>
    </div>
  );
};
